<div class="flex gap-2">
  <app-pan-button color="warning" [swal]="unarchiveSwal">Unarchive</app-pan-button>
</div>

<swal
  #unarchiveSwal
  title="Unarchive Location?"
  text="Are you sure you want to unarchive this location?"
  icon="warning"
  confirmButtonText="Yes, Unarchive"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="params.unarchiveCallback(params.data)"
>
</swal>
